import * as React from "react";
import { AppointmentForm } from "@devexpress/dx-react-scheduler-material-ui";

export default function CommandButton({ id, ...restProps }) {
  if (id === "saveButton" || id === "deleteButton") {
    return null;
  }
  return <AppointmentForm.CommandButton id={id} {...restProps} />;
}
